import React from "react";
import { PiClockBold } from "react-icons/pi";

/**
 * Stub section. Per the brief, Payments and Taxonomy keep their nav entry but
 * do not ship a real page this pass — both need backend data models that aren't
 * wired up yet. The stub names what it will hold so the gap is legible rather
 * than looking like a broken route.
 */
const ComingSoon = ({ title, blurb, willInclude = [] }) => (
  <div className="admin-stub">
    <div className="admin-stub-mark"><PiClockBold /></div>
    <h4 style={{ margin: 0 }}>{title} — coming soon</h4>
    <p className="card-body" style={{ flex: "none", maxWidth: 460 }}>{blurb}</p>

    {willInclude.length > 0 && (
      <div className="admin-chips" style={{ justifyContent: "center", maxWidth: 460 }}>
        {willInclude.map((item) => (
          <span className="tag tag-outline" key={item}>{item}</span>
        ))}
      </div>
    )}
  </div>
);

export const PaymentsStub = () => (
  <ComingSoon
    title="Payments"
    blurb="Stripe transactions, entitlements and the dispute triage queue. Held back
           until the billing data model is wired up — the design is complete and
           ready to build against real data."
    willInclude={["Transactions", "Entitlements", "Failed & disputed triage", "Seat usage"]}
  />
);

export const TaxonomyStub = () => (
  <ComingSoon
    title="Taxonomy"
    blurb="Read-only reference data driving automated decisions: categories, their
           trades, and the phased task templates behind each project type. Managed
           via code review rather than edited here."
    willInclude={["Categories", "Trades", "Project types", "Phase templates"]}
  />
);

export default ComingSoon;
